import styled from "styled-components";
export const BodyTextContainer = styled.span `
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #666666;
`;
